import type { RefObject } from 'react';

import { useSmoothScroll } from './useSmoothScroll';

interface UseButtonScrollProps {
  gap?: number;
  tagName?: React.ElementType;
}

interface UseButtonScrollReturn {
  scrollLeft: () => void;
  scrollRight: () => void;
}

export const useButtonScroll = (
  containerRef: RefObject<HTMLElement>,
  { gap = 8, tagName = 'article' }: UseButtonScrollProps = {},
): UseButtonScrollReturn => {
  const { smoothScrollBy } = useSmoothScroll(containerRef);

  const getItemWidth = () => {
    if (!containerRef.current) return 0;

    const item = containerRef.current.querySelector(tagName as string) as HTMLElement | null;
    return item?.offsetWidth || 0;
  };

  const scrollLeft = () => {
    const itemWidth = getItemWidth();
    if (itemWidth) smoothScrollBy(-(itemWidth + gap));
  };

  const scrollRight = () => {
    const itemWidth = getItemWidth();
    if (itemWidth) smoothScrollBy(itemWidth + gap);
  };

  return { scrollLeft, scrollRight };
};
